export class AutomatisationSavingsTool
{
    constructor(tool)
    {

        this.sliders = {
            employees : tool.querySelector('input#employees'),
            hourly_rate : tool.querySelector('input#hourly_rate'),
            hours: tool.querySelector('input#hours'),
        };

        this.totalNodes = {
            per_month : tool.querySelector('[data-total-month] > span'),
            per_year : tool.querySelector('[data-total-year] > span'),
        };

        this.watchSliders();
    }

    watchSliders()
    {
        const update = (slider, key) => {
            let value = slider.value;
            const parent = slider.closest('.tool__input');

            if(key === 'hours') value += 'h';
            if(key === 'hourly_rate') value = '€' + value;

            parent.dataset.value = value;
            this.calculateTotals();
        }

        Object.keys(this.sliders).forEach((key) => {
            const slider = this.sliders[key];

            update(slider, key);

            slider.addEventListener('input', (e) => {
                update(slider, key);
            });
        })
    }

    calculateTotals()
    {
        const totals = {
            per_employee : 0,
            per_month : 0,
            per_year : 0,
        }

        totals.per_employee = this.sliders.employees.value * this.sliders.hours.value;
        totals.per_employee = totals.per_employee * this.sliders.hourly_rate.value;

        totals.per_month = totals.per_employee * 22;
        totals.per_year  = totals.per_employee * 231;

        Object.keys(this.totalNodes).forEach((key) => {
            const node = this.totalNodes[key];

            const formatted = new Intl.NumberFormat('nl-NL', {
                style: 'currency',
                currency: 'EUR',
            }).format(totals[key]);

            if(node){
                node.innerText = formatted;
            }
        })

        console.log(totals);
    }
}
